import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { Timeframe } from "@/types/peopleSearch";

interface TimeframeToggleProps {
	value: Timeframe;
	onChange: (value: Timeframe) => void;
}

const OPTIONS: Timeframe[] = ["current", "former", "both"];

export function TimeframeToggle({ value, onChange }: TimeframeToggleProps) {
	const { t } = useTranslation();

	return (
		<div className="flex items-center gap-2">
			<span className="text-sm text-muted-foreground">{t("peopleSearch.timeframe.label", "Timeframe")}</span>
			<div
				role="radiogroup"
				aria-label={t("peopleSearch.timeframe.label", "Timeframe")}
				className="inline-flex items-center rounded-sm bg-muted p-0.5"
			>
				{OPTIONS.map(option => {
					const selected = value === option;
					return (
						<button
							key={option}
							type="button"
							role="radio"
							aria-checked={selected}
							onClick={() => onChange(option)}
							className={cn(
								"px-3 py-1 text-sm font-medium rounded-sm transition-colors",
								selected
									? "bg-background text-foreground shadow-sm"
									: "text-muted-foreground hover:text-foreground"
							)}
						>
							{t(`peopleSearch.timeframe.${option}`, option)}
						</button>
					);
				})}
			</div>
		</div>
	);
}
